module.exports = {
  "country": "PT",
  "artist": "Iolanda",
  "song": "Grito",
  "year": "2024",
  "place": "10",
  "spotify": "1MJqdZY2srI7SVxLO6fJ1s"
};